<template>
  <div
    :style="{width: `${getBarWidth}px`}"
    class="bar" />
</template>
<script>
export default {
  props: {
    perc: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      roundedPerc: 0,
    };
  },
  computed: {
    getBarWidth() {
      return (window.innerWidth / 100) * this.getRoundedPerc();
    },
  },
  methods: {
    getRoundedPerc() {
      return this.perc;
    },
  },
};
</script>
<style lang="scss" scoped>
.bar {
  position: -webkit-sticky;
  position: sticky;
  height: 3px;
  width: 100vw;
  left: 0;
  top: 0;
  background-color: #ea1c00;
  transition: width 0.1s;
  overflow:hidden;
  -webkit-overflow-scrolling:touch;
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue